import { render } from "./WCLoginMenu.vue?vue&type=template&id=903bbf56&scoped=true&ts=true"
import script from "./WCLoginMenu.vue?vue&type=script&lang=ts"
export * from "./WCLoginMenu.vue?vue&type=script&lang=ts"

import "./WCLoginMenu.vue?vue&type=style&index=0&id=903bbf56&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-903bbf56"]])

export default __exports__